// extracted by mini-css-extract-plugin
export var searchHeader = "_5b-0";
export var searchHeaderDark = "_5b-1";